import { PlanDetails } from './../../domain/models/plan-details';

import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { PlansRepository } from "../../repositories";
import { Observable } from 'rxjs';
import { BaseRequest } from "planning-portal-library/src/lib/data/shared/base.request";
import { PlanDetailsRequest } from '../../domain/requests/plans/plan-details-request';

// @Injectable({ providedIn: 'root' })
// export class GetAllPlanJobsUsecase implements UseCase<BaseRequest<PlanDetailsRequest>, PlanDetails[]> {

//   constructor(private readonly planRepository: PlansRepository) {
//   }

//   execute(params: BaseRequest<PlanDetailsRequest>): Observable<PlanDetails[]> {
//     return this.planRepository.getAllPlanJobs(params);
//   }

// }